<mat-chip-set>
  @if (contactsLoading) {
  <mat-chip> Loading ... </mat-chip>
  } @else { @for (contact of selectedContacts; track $index) {
  <mat-chip [removable]="true" (removed)="removeRecipient($index)">
    {{ contact?.firstName }} {{ contact?.lastName }}
    <button matChipRemove [attr.aria-label]="'Remove ' + contact?.firstName + ' ' + contact?.lastName" [tabIndex]="0">
      <mat-icon>cancel</mat-icon>
    </button>
  </mat-chip>
  } @empty {
  <mat-chip>
    {{ 'Integrations.Weather.Custom.SelectedContactsNone' | translate : locale.language }}
  </mat-chip>
  } }
</mat-chip-set>
<div style="margin-top: 15px;">
  <button mat-raised-button (click)="selectContacts()">
    <mat-icon>add</mat-icon>
    {{ 'Integrations.Weather.Custom.SelectContactsAdd' | translate : locale.language }}
  </button>
</div>